import React from 'react';
import { ApolloQueryResult } from '@apollo/client';
import AddIcon from '@atlaskit/icon/glyph/editor/add';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import Modal, { ModalHeader, ModalTransition } from '@atlaskit/modal-dialog';
import { Box, xcss, Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useOpenClose } from '@css-xp/ppc-custom-hooks';
import { EditShipToPartyContentEnum, ShipToPartySidebar } from '@css-xp/ppc-ship-to-party-sidebar';
import { ShipToPartyBodyWrapper, CloseButton } from './add-new-address.styles';

interface AddNewAddressProps {
  companyName: string | undefined;
  transactionAccountId: string;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
}

export const AddNewAddress = ({ companyName, transactionAccountId, refetch }: AddNewAddressProps) => {
  const { isOpen, open, close } = useOpenClose();

  return (
    <>
      <Box xcss={xcss({ display: 'inline', marginLeft: 'space.100' })}>
        <IconButton
          onClick={open}
          icon={AddIcon}
          label="New address"
          isTooltipDisabled={false}
          spacing="compact"
          testId="add-new-address-button"
        />
      </Box>
      <ModalTransition>
        {isOpen && (
          <Modal shouldScrollInViewport onClose={close}>
            <ModalHeader>
              <Text weight="medium" size="large">
                Add a new address
              </Text>
              <CloseButton onClick={close} data-testid="sidebar-close">
                <CrossIcon size="small" label="Close Modal" primaryColor={token('color.text.subtlest')} />
              </CloseButton>
            </ModalHeader>
            <ShipToPartyBodyWrapper>
              <ShipToPartySidebar
                shipToAddress={{
                  name: companyName,
                }}
                transactionAccountId={transactionAccountId}
                onSubmitComplete={close}
                refetch={refetch}
                shouldHideHeader
                contentString={{
                  [EditShipToPartyContentEnum.SUBMIT_BUTTON]: 'Add',
                  [EditShipToPartyContentEnum.BILLING_PROFILE_UPDATE_SUCCESS]: 'Address added',
                  [EditShipToPartyContentEnum.ADDRESS_NAME_LABEL]: 'Customer',
                }}
                isAddType
                shouldHideCancelButton
                shouldHideNotificationDescription
              />
            </ShipToPartyBodyWrapper>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};
